module.exports = __webpack_public_path__ + "img/carteirinhaGatoFrente_3.5237e6a3.jpeg";